module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sv":{"checking-student-status":"Verifierar din {membertype}status","customer-service":"Kundtjänst","customer-service-link":"https://help.mecenat.com/hc/sv"},"en":{"checking-student-status":"Verifying your {membertype}status","customer-service":"Customer service","customer-service-link":"https://help.mecenat.com/hc/en-gb"}}')
  delete Component.options._Ctor
}
